import React from 'react';
import { Canvas } from '@react-three/fiber';
import { Text, Float } from '@react-three/drei';

const ThreeBrainIcon = () => {
    return (
        <Canvas gl={{ alpha: true }} camera={{ position: [0, 0, 5], fov: 50 }}>
            <ambientLight intensity={1} />
            <Float speed={2} rotationIntensity={0.5} floatIntensity={0.5}>
                <Text
                    fontSize={2.5}
                    color="#ffffff" // White
                    anchorX="center"
                    anchorY="middle"
                >
                    🧠
                    {/* Emissive material to make it 'pop' and look like the arcade version */}
                    <meshStandardMaterial
                        color="#ffffff"
                        emissive="#ffffff"
                        emissiveIntensity={0.6}
                        toneMapped={false}
                    />
                </Text>
            </Float>
        </Canvas>
    );
};

export default ThreeBrainIcon;
